import { cn } from '../../../utils/string/cn.utils';

const ButtonIconGhostLarge = ({ id, icon, active = false, ...props }) => {
  return (
    <button
      id={id}
      type="button"
      {...props}
      className={cn(
        'flex justify-center items-center rounded-[100px] text-black-medium hover:bg-primary-primaryVarient1 hover:text-white-high disabled:text-[#ACACAC]',
        'w-[40px] h-[40px] p-[4px]',
        active && 'bg-primary-primary text-white-high',
        props.className
      )}
    >
      {icon && (
        <div className="w-24 h-24 flex justify-center items-center">{icon}</div>
      )}
    </button>
  );
};

export default ButtonIconGhostLarge;
